import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { ConstructDelete } from '../../types/ConstructDelete';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const deleteTemplateInstance = (
  constructDelete: ConstructDelete,
  instanceId: string,
): Promise<unknown> =>
  constructDelete(
    `${SIGNATURE_BASE_PATH}/template-instance/${instanceId}`,
    undefined,
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
